/* sm-brusi-vel.js - the Owala bottle engine (assets/sm-brusi.js 1.0.1, live 746abb2d) as a library for the one
   product page kit (sections/sm-vel.liquid, adapter assets/sm-vs-brusi.js). Samraeming L6, 2026-09-29.

   K2 pattern: every line between the markers below is copied BYTE FOR BYTE from the live sm-brusi.js (line
   numbers in the marker), so geometry, measuring, fit rules, logo analysis, the production spec and the cart
   property values are the same code as the old page. Only the wrapper is new: the engine lives in a factory,
   window.SMBrusiVel(G, ORD, opt), instead of an IIFE bound to [data-bs-sida]; G and ORD have the old page's
   shapes (data-bs-gogn, data-bs-ord). opt.rot is the element that holds the measuring span [data-bs-maeli],
   opt.render() is called when a font has loaded (the old render()). The state the old code read from its
   closure variable st is set with setjaSt(s) before a call that needs it (heitiGsL, logoMjott, tillogur,
   uppruniLogo, smamynd). The old page keeps its own sm-brusi.js, unchanged.
   ES5, ASCII only. Built by samraeming/L6-brusar/src/build.mjs.
   E4 (2026-09-30, samraeming/E4-owala-logo/src/build.mjs): logoMal scales S and M from the largest L that fits.
   stal-letur (2026-10-01, brusar/stal-letur/src/build.mjs): no minimum letter size, a too long text is scaled down
   to fit (textiMal, preview and production alike), brushed steel letters (svgAf), size add-on texts. */
(function () {
  "use strict";
  if (window.SMBrusiVel) return;
  function vel(G, ORD, opt) {
  opt = opt || {};
  var rot = opt.rot || document.createElement("div");
  function render() { if (typeof opt.render === "function") opt.render(); }
  /* ---- sm-brusi.js 1.0.1 lines 35-114 (verbatim) ---- */
  var UTGAFA = "1.0.1";

  /* ================= G\u00d6GN (Owala: owalalife.com; m\u00e6lt af myndum Owala, um +-3 mm) ================= */
  /* Myndirnar: allar \u00e1 s\u00f6mu r\u00famfr\u00e6\u00f0i (src/myndir/gera-myndir.py) */
  var MYND = { k: 3.2, w: 384, h: 928, botn: 896, midja: 192 };
  var MYND_MM = { w: MYND.w / MYND.k, h: MYND.h / MYND.k, botn: MYND.botn / MYND.k, midja: MYND.midja / MYND.k };
  /* haed og thvermal: Owala. bolur, beint, oxl: st\u00e1lbolurinn m\u00e6ldur af m\u00e1lsmyndum Owala. owala: botn Owala
     merkisins (m\u00e6lt \u00e1 myndunum 26,3 til 27,0 mm). svaedi: 2 cm fr\u00e1 botni, 3 cm undir \u00f6xl (24 oz: undir lokinu).
     Lengdin sem nafni\u00f0 m\u00e1 n\u00e1 er svaedi[1] - owala (24 oz 150,5 mm, 32 oz 131,5 mm); stafafj\u00f6ldinn \u00ed teljaranum
     er reikna\u00f0ur \u00far henni (hamark), m\u00e6lda breiddin r\u00e6\u00f0ur hvort textinn passar. */
  var STAERDIR = {
    "710": { ml: 710, oz: 24, haed: 271, thvermal: 79.2, bolur: 207, beint: [12, 207], oxl: null, owala: 26.5, svaedi: [20, 177] },
    "945": { ml: 945, oz: 32, haed: 271, thvermal: 87.1, bolur: 206, beint: [12, 188], oxl: [188, 206], owala: 26.5, svaedi: [20, 158] }
  };
  /* Litir: grafa = litur st\u00e1lsins \u00ed forsko\u00f0un, ljomi = text-shadow (Claude Design), logo = gr\u00e1t\u00f3nn logosins
     (brightness(0) invert(.8) = 204, invert(.65) = 166), veggur eftir reglu eigandans. */
  var LITIR = {
    svartur: { owala: "Very, Very Dark", heiti: "Svartur", grafa: "#c8cbcf", ljomi: [[0, 0, 1, "#ffffff", 0.35], [0, 1, 0, "#ffffff", 0.15]], logo: 204, veggur: "ljos", kontrast: false, brun: "#0b0c0d", stal: { ljos: 0.26, dokkt: 0.34, grunn: "rgba(255,255,255,0.04)" } },
    hvitur: { owala: "Shy Marshmallow", heiti: "Hv\u00edtur", grafa: "#a3a7ab", ljomi: [[0, 0, 1, "#000000", 0.15]], logo: 166, veggur: "dokkur", kontrast: true, brun: "#9a9da1", stal: { ljos: 0.14, dokkt: 0.26, grunn: "rgba(0,0,0,0.10)" } }
  };
  /* Letur: margf = leturst\u00e6r\u00f0 / h\u00e1stafah\u00e6\u00f0 (Claude Design), bil = stafabil \u00ed em, hofud = h\u00e1stafah\u00e6\u00f0 letursins
     sj\u00e1lfs (H / em, \u00far leturskr\u00e1num), notu\u00f0 til a\u00f0 mi\u00f0ja h\u00e1stafina \u00e1 br\u00fasanum. stafur = d\u00e6miger\u00f0 breidd \u00e1 staf
     \u00ed em me\u00f0 stafabili og bilum (me\u00f0altal 20 algengra \u00edslenskra nafna m\u00e6lt \u00ed leturskr\u00e1num), a\u00f0eins fyrir teljarann. */
  var GF = "google/fonts ofl/";
  var LETUR = {
    bebas: { id: "bebasneue-400", fam: "SMBbebas", nafn: "Bebas Neue", thykkt: 400, margf: 1.4, bil: 0.12, hastafir: true, hofud: 0.7, stafur: 0.491, uppruni: GF + "bebasneue/BebasNeue-Regular.ttf Version 2.000" },
    quicksand: { id: "quicksand-700", fam: "SMBrundad", nafn: "Quicksand", thykkt: 700, margf: 1.43, bil: 0.04, hastafir: false, hofud: 0.7, stafur: 0.577, uppruni: GF + "quicksand/Quicksand[wght].ttf Version 3.006 (wght 700, SMF Rundad)" },
    dancing: { id: "dancingscript-700", fam: "SMBskrift", nafn: "Dancing Script", thykkt: 700, margf: 1.6, bil: 0, hastafir: false, hofud: 0.721, stafur: 0.435, uppruni: GF + "dancingscript/DancingScript[wght].ttf Version 2.001" }
  };
  var LETUR_ROD = ["bebas", "quicksand", "dancing"];
  var TEXTI_MM = { S: 8, M: 12, L: 18 }, LOGO_MM = { S: 70, M: 90, L: 110 }, GSTAERDIR = ["S", "M", "L"];
  var LOGO_THVERT = 30;   /* mesta breidd logos \u00fevert \u00e1 br\u00fasann, mm (sveigjan: rannsokn.md 2) */
  var DPI_PNG = 300, DPI_SKRA = 600, DPI_HAMARK = 1200, MIN_STROKA = 0.4;
  var STAFIR = {"bebasneue-400":[[32,126],[160,382],[536,539],[710,711],[728,733],[8210,8212],[8216,8218],[8220,8222],[8224,8226],[8230,8230],[8240,8240],[8249,8250],[8260,8260],[8364,8364],[8470,8470],[8482,8482],[8722,8722]],"quicksand-700":[[32,126],[160,382],[536,539],[710,711],[728,733],[8208,8208],[8210,8212],[8216,8218],[8220,8222],[8224,8226],[8230,8230],[8240,8240],[8243,8243],[8249,8250],[8260,8260],[8364,8364],[8470,8470],[8482,8482],[8722,8722]],"dancingscript-700":[[32,126],[160,382],[536,539],[710,711],[728,733],[8211,8212],[8216,8218],[8220,8222],[8224,8226],[8230,8230],[8240,8240],[8249,8250],[8260,8260],[8364,8364],[8470,8470],[8482,8482],[8722,8722]]};   /* stafir sem hvert letur hefur (k\u00f3\u00f0apunktar, bil), \u00far leturskr\u00e1num */
  var STADSETNING = "vertical-owala-line";
  var SKRA_SPASSIA = 5;   /* mm umhverfis br\u00fasann \u00ed skr\u00e1nni */

  /* ================= Sm\u00e1f\u00f6ll ================= */
  function t(k, v) {
    var s = ORD[k] != null ? String(ORD[k]) : "";
    if (v) s = s.replace(/\{(\w+)\}/g, function (m, n) { return v[n] != null ? String(v[n]) : m; });
    return s;
  }
  function $(s, r) { return (r || rot).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || rot).querySelectorAll(s)); }
  function trim(s) { return String(s == null ? "" : s).replace(/^\s+|\s+$/g, ""); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function thus(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, "."); }
  function kr(aurar) { var n = Math.round((Number(aurar) || 0) / 100); return (n < 0 ? "-" : "") + thus(Math.abs(n)) + " kr."; }
  function setTexti(el, s) { if (el && el.textContent !== s) el.textContent = s; }
  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function mm1(v) { return String(Math.round(v * 10) / 10).replace(".", ","); }
  function mm0(v) { return String(Math.round(v)); }
  /* logo sizes: one decimal under 5 mm so a very tall logo still reads S<M<L */
  function mmL(v) { return v < 5 ? mm1(v) : mm0(v); }
  function r4(v) { return Math.round(v * 1e4) / 1e4; }
  function r3(v) { return Math.round(v * 1e3) / 1e3; }
  function nfc(s) { s = String(s == null ? "" : s); try { if (s.normalize) s = s.normalize("NFC"); } catch (e) {} return s; }
  function kodapunktar(s) {
    var o = [], i, c;
    for (i = 0; i < s.length; i++) {
      c = s.charCodeAt(i);
      if (c >= 0xd800 && c <= 0xdbff && i + 1 < s.length) { var d = s.charCodeAt(i + 1); if (d >= 0xdc00 && d <= 0xdfff) { o.push(((c - 0xd800) << 10) + (d - 0xdc00) + 0x10000); i++; continue; } }
      o.push(c);
    }
    return o;
  }
  function fraKodum(cps) { var s = "", i, c; for (i = 0; i < cps.length; i++) { c = cps[i]; if (c > 0xffff) { c -= 0x10000; s += String.fromCharCode(0xd800 + (c >> 10), 0xdc00 + (c & 1023)); } else s += String.fromCharCode(c); } return s; }
  function hefurStaf(id, c) {
    var b = STAFIR[id]; if (!b) return true;
    var lo = 0, hi = b.length - 1;
    while (lo <= hi) { var m = (lo + hi) >> 1; if (c < b[m][0]) hi = m - 1; else if (c > b[m][1]) lo = m + 1; else return true; }
    return false;
  }
  var LITIL_HREYFING = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  var TAKN_RE;
  try { TAKN_RE = new RegExp("[\\p{Extended_Pictographic}\\u{1F1E6}-\\u{1F1FF}\\u{1F3FB}-\\u{1F3FF}\\u{E0020}-\\u{E007F}\\u20E3\\uFE0E\\uFE0F\\u200D]", "u"); }
  catch (e) { TAKN_RE = /[\uD83C-\uDBFF][\uDC00-\uDFFF]|[\u2600-\u27bf]|\ufe0f|\u200d/; }

  /* Fastir lyklar og gildi \u00ed k\u00f6rfu (\u00edslenska, l\u00edka \u00e1 \u00f6\u00f0rum tungum\u00e1lum) */
  var EIG = { aletrun: "\u00c1letrun", texti: "Texti", letur: "Letur", stafahaed: "Stafah\u00e6\u00f0", logo: "Logo", logolengd: "St\u00e6r\u00f0 logos", stadsetning: "Sta\u00f0setning", aths: "Athugasemdir me\u00f0 p\u00f6ntun" };
  var EIG_GILDI = { texti: "Texti", logo: "Logo", stadsetning: "L\u00f3\u00f0r\u00e9tt upp s\u00ed\u00f0una, \u00ed l\u00ednu vi\u00f0 Owala merki\u00f0" };
  /* ---- sm-brusi.js 1.0.1 lines 116-146 (verbatim) ---- */
  /* ================= Vara: hlutverk eftir r\u00f6\u00f0, gildi eftir s\u00e6ti ================= */
  var IX = {}, KODAR = G.kodar || {}, KODAR_OK = true, HLUTVERK = ["staerd", "litur"];
  var KODI_GILDUR = { staerd: function (x) { return has(STAERDIR, x); }, litur: function (x) { return has(LITIR, x); } };
  function villaKodar(s) { KODAR_OK = false; if (window.console) console.warn("sm-brusi: " + s + " S\u00ed\u00f0an selur ekki fyrr en \u00fea\u00f0 er laga\u00f0."); }
  (G.hlutverk || []).forEach(function (h, i) { if (IX[h] != null) villaKodar("hlutverki\u00f0 '" + h + "' kemur tvisvar."); IX[h] = i; });
  if ((G.hlutverk || []).length !== (G.opts || []).length) villaKodar("hlutverk valkosta passa ekki vi\u00f0 fj\u00f6lda valkosta v\u00f6runnar (" + (G.opts || []).length + ").");
  (G.hlutverk || []).forEach(function (h) { if (HLUTVERK.indexOf(h) < 0) villaKodar("\u00f3\u00feekkt hlutverk '" + h + "'."); });
  if (IX.staerd == null || IX.litur == null) villaKodar("varan \u00fearf valkost fyrir st\u00e6r\u00f0 og lit.");
  HLUTVERK.forEach(function (h) {
    if (IX[h] == null) return;
    var o = G.opts[IX[h]], k = KODAR[h], sed = {};
    var ok = !!o && !!k && o.v.length === k.length && k.every(function (x) { var nytt = !sed[x]; sed[x] = 1; return nytt && KODI_GILDUR[h](x); });
    if (!ok) villaKodar("k\u00f3\u00f0ar fyrir '" + h + "' passa ekki vi\u00f0 v\u00f6runa.");
  });
  function gildiAf(h, kodi) { var i = (KODAR[h] || []).indexOf(kodi); return i < 0 || IX[h] == null ? null : G.opts[IX[h]].v[i]; }
  function kodiAf(h, gildi) { var i = IX[h] == null ? -1 : G.opts[IX[h]].v.indexOf(gildi); return i < 0 ? null : (KODAR[h] || [])[i] || null; }
  function finna(k) {
    if (!KODAR_OK) return null;
    var vv = G.variants || [], i, h;
    for (i = 0; i < vv.length; i++) {
      var ok = true;
      for (h in IX) {
        if (!has(IX, h)) continue;
        var g = gildiAf(h, k[h]);
        if (g == null || vv[i].o[IX[h]] !== g) { ok = false; break; }
      }
      if (ok) return vv[i];
    }
    return null;
  }

  /* ---- the state (new): the old closure variable st, set by the adapter before each call ---- */
  var st = { staerd: "710", litur: "svartur", hamur: "texti", texti: "", letur: "bebas", ts: "M", ls: "M",
    logo: null, logoSkra: null, logoVilla: "", logoGreinir: false, magn: 1, aths: "", reynt: false, snert: false };
  function setjaSt(s) { st = s; athCache = null; }
  /* ---- sm-brusi.js 1.0.1 lines 160-162 (verbatim) ---- */
  function val(o) { var k = { staerd: st.staerd, litur: st.litur }, x; for (x in o) if (has(o, x)) k[x] = o[x]; return k; }
  function afbrigdi() { return finna(val({})); }
  function afrit(s) { var o = {}, x; for (x in s) if (has(s, x)) o[x] = s[x]; return o; }
  /* ---- sm-brusi.js 1.0.1 lines 164-206 (verbatim) ---- */
  /* ================= Letri\u00f0: s\u00f6mu skr\u00e1r og SMFram ================= */
  var leturKlar = {}, leturVilla = false, leturGogn = {};
  function b64Buf(s) { var bin = window.atob(s), n = bin.length, u = new Uint8Array(n), i; for (i = 0; i < n; i++) u[i] = bin.charCodeAt(i); return u.buffer; }
  function skraIKjarna(f) {
    var L = LETUR[f], F = window.SMFram, buf = leturGogn[f];
    if (!F || !F.skraLetur || !buf || L.skrad) return;
    try {
      F.skraLetur(L.id, { gogn: buf.slice(0), url: G.slodir && G.slodir.letur && G.slodir.letur[L.id], nafn: L.nafn, thykkt: L.thykkt, uppruni: L.uppruni, gf: true });
      L.skrad = true;
    } catch (e) { if (window.console) console.warn("sm-brusi: skraLetur " + L.id + " " + (e && e.message)); }
  }
  function hladaEittLetur(f) {
    var L = LETUR[f], url = G.slodir && G.slodir.letur && G.slodir.letur[L.id];
    if (!url) return Promise.reject(new Error("engin sl\u00f3\u00f0 " + L.id));
    return fetch(url, { credentials: "same-origin" }).then(function (r) {
      if (!r.ok) throw new Error(L.id + " " + r.status);
      return r.json();
    }).then(function (o) {
      if (!o || o.id !== L.id || !o.b64) throw new Error(L.id + " sni\u00f0");
      var buf = b64Buf(o.b64);
      if (o.bytes && buf.byteLength !== o.bytes) throw new Error(L.id + " lengd");
      leturGogn[f] = buf;
      skraIKjarna(f);
      if (!window.FontFace || !document.fonts) throw new Error("FontFace");
      var ff = new window.FontFace(L.fam, buf.slice(0), { weight: "400", style: "normal" });
      return ff.load().then(function (x) { document.fonts.add(x); leturKlar[f] = true; maeliC = {}; });
    });
  }
  var hladid = null;
  function hladaLetur() {
    if (hladid) return hladid;
    var fyrst = st.letur, bid = [];
    hladid = hladaEittLetur(fyrst).then(function () {
      render();
      LETUR_ROD.forEach(function (f) { if (f !== fyrst) bid.push(hladaEittLetur(f).then(function () { render(); })); });
      return Promise.all(bid);
    })["catch"](function (e) {
      if (!leturKlar[st.letur]) leturVilla = true;
      render();
      if (window.console) console.warn("sm-brusi: letur " + (e && e.message));
    });
    return hladid;
  }
  /* ---- sm-brusi.js 1.0.1 lines 208-259 (verbatim) ---- */
  /* ================= M\u00e6ling og m\u00e1tun ================= */
  var maeliEl = $("[data-bs-maeli]"), maeliC = {}, maeliCtx = null;
  try { maeliCtx = document.createElement("canvas").getContext("2d"); } catch (e) { maeliCtx = null; }
  /* Texti eins og hann fer \u00e1 br\u00fasann: NFC, eitt bil, Bebas \u00ed h\u00e1st\u00f6fum, a\u00f0eins stafir sem letri\u00f0 hefur */
  function textiA(s, f) {
    var x = nfc(s).replace(/\s+/g, " ");
    x = trim(x);
    if (LETUR[f].hastafir) x = x.toUpperCase();
    return x;
  }
  function stafafjoldi(x) { return kodapunktar(x.replace(/\s+/g, "")).length; }
  /* breidd \u00ed em (margfalda\u00f0 me\u00f0 leturst\u00e6r\u00f0 = mm), fr\u00e1 upphafspunkti pennans: adv = framr\u00e1s \u00e1n aftasta stafabils,
     blekH = h\u00e6gri br\u00fan bleks, vinstri = hve langt bleki\u00f0 n\u00e6r vinstra megin vi\u00f0 pennann (neikv\u00e6tt = bleki\u00f0 byrjar
     \u00e1 eftir honum, t.d. hli\u00f0arbil fyrsta stafs). Bleki\u00f0, ekki penninn, byrjar \u00e1 l\u00ednu Owala merkisins. */
  function maela(f, x) {
    var k = f + "|" + x;
    if (maeliC[k]) return maeliC[k];
    var L = LETUR[f], n = kodapunktar(x).length, adv = 0, blekH = 0, vinstri = 0;
    if (maeliEl && n) {
      maeliEl.style.fontFamily = L.fam; maeliEl.style.letterSpacing = L.bil + "em";
      maeliEl.textContent = x;
      adv = maeliEl.getBoundingClientRect().width / 100 - L.bil;
      blekH = adv;
      if (maeliCtx) {
        maeliCtx.font = "100px " + L.fam;
        var m = maeliCtx.measureText(x);
        if (typeof m.actualBoundingBoxRight === "number") { blekH = m.actualBoundingBoxRight / 100 + L.bil * (n - 1); vinstri = (m.actualBoundingBoxLeft || 0) / 100; }
      }
    }
    var r = { adv: adv, blekH: blekH, vinstri: vinstri, endi: Math.max(adv, blekH) };
    maeliC[k] = r;
    return r;
  }
  /* d\u00e6miger\u00f0ur h\u00e1marksfj\u00f6ldi stafa: laus lengd br\u00fasans / d\u00e6miger\u00f0 stafbreidd letursins \u00ed \u00feessari st\u00e6r\u00f0 */
  function hamarkStafa(staerd, f, ts) { var S = STAERDIR[staerd], L = LETUR[f]; return Math.floor((S.svaedi[1] - S.owala) / (L.stafur * L.margf * TEXTI_MM[ts]) + 1e-9); }
  function textiMal(s, ts, f) {
    s = s || st; ts = ts || s.ts; f = f || s.letur;
    var S = STAERDIR[s.staerd], L = LETUR[f], x = textiA(s.texti, f);
    var cap0 = TEXTI_MM[ts], cap = cap0, M = maela(f, x), laust = S.svaedi[1] - S.owala, em = M.endi + M.vinstri, minnkad = false;
    /* stal-letur (owner 01.10): a size is never refused. A text that would run past the engraving area is scaled
       down until it fits (to 0,01 mm), the chosen size is then its largest letter height. The preview (svgAf) and
       the production file (specAf) both read this cap, so they are the same engraving. */
    if (em > 0 && em * cap0 * L.margf > laust + 1e-6) { cap = Math.floor(laust / (em * L.margf) * 100) / 100; minnkad = true; }
    var fs = cap * L.margf;
    var pen = S.owala + M.vinstri * fs, lengd = em * fs;
    var n = stafafjoldi(x), hamark = hamarkStafa(s.staerd, f, ts);
    return { x: x, cap: cap, cap0: cap0, minnkad: minnkad, fs: fs, capA: fs * L.hofud, pen: pen, lengd: lengd, laust: laust, n: n, hamark: hamark,
      passar: lengd <= laust + 1e-6, leyft: true };
  }
  function logoMal(s, ls) {
    s = s || st; ls = ls || s.ls;
    var lg = s.logo; if (!lg) return null;
    /* E4: L is the largest engraving that fits (LOGO_MM.L along, at most LOGO_THVERT across); S and M keep the
       proportions LOGO_MM[g] / LOGO_MM.L of it in both dimensions, so every logo grows S < M < L */
    var L = LOGO_MM[ls], lL = LOGO_MM.L, hL = lL / lg.r;
    if (hL > LOGO_THVERT) { hL = LOGO_THVERT; lL = hL * lg.r; }
    var k = L / LOGO_MM.L, l = lL * k, h = hL * k;
    var dpi = lg.gerd === "png" ? lg.pxB / (l / 25.4) : Infinity;
    return { l: l, h: h, nafn: L, hatt: lL < LOGO_MM.L - 0.05, thvert: LOGO_THVERT, lMest: LOGO_MM.L, dpi: dpi, minPx: Math.ceil(DPI_PNG * l / 25.4), passar: dpi >= DPI_PNG - 1e-6 };
  }
  /* ---- sm-brusi.js 1.0.1 lines 261-302 (verbatim) ---- */
  /* ================= Vandam\u00e1l [{kodi, reitur, stopp, texti, hnappur, tillogur}] ================= */
  var athCache = null;
  function athuga(s) {
    s = s || st;
    var ut = [];
    if (!KODAR_OK || !finna(val({ staerd: s.staerd, litur: s.litur }))) { ut.push({ kodi: "ekki_i_bodi", stopp: true, texti: t("ekki_i_bodi"), hnappur: t("ekki_i_bodi") }); return ut; }
    if (s.hamur === "texti") {
      if (!trim(s.texti)) { ut.push({ kodi: "vantar", reitur: "texti", stopp: true, texti: t("vantar_texti_texti"), hnappur: t("vantar_texti") }); return ut; }
      if (leturVilla && !leturKlar[s.letur]) { ut.push({ kodi: "hledst_ekki", stopp: true, texti: t("hledst_ekki"), hnappur: t("hledst_ekki_hnappur") }); return ut; }
      if (!leturKlar[s.letur]) { ut.push({ kodi: "hledst", stopp: true, texti: t("hledst"), hnappur: t("baeta") }); return ut; }
      var M = textiMal(s);
      /* m\u00e6lda breiddin r\u00e6\u00f0ur, ekki stafafj\u00f6ldinn. Einn aukastafur, lengdin n\u00e1mundu\u00f0 upp og lausa lengdin ni\u00f0ur,
         svo t\u00f6lurnar stangist aldrei \u00e1 (131,6 mm en 131,5 mm laus) */
      /* stal-letur: no "too long" stop any more, textiMal scaled the text to fit (M.minnkad) */
      if (!M.passar && window.console) console.warn("sm-brusi: textinn passar ekki eftir minnkun (" + M.lengd + " > " + M.laust + ")");
    } else {
      if (s.logoGreinir) { ut.push({ kodi: "greinir", reitur: "logo", stopp: true, texti: "", hnappur: t("logo.greinir") }); return ut; }
      if (!s.logo) { ut.push({ kodi: s.logoVilla ? "logo_villa" : "vantar_logo", reitur: "logo", stopp: true, texti: s.logoVilla || t("vantar_logo_texti"), hnappur: s.logoVilla ? t("logo_villa_hnappur") : t("vantar_logo") }); return ut; }
      var ML = logoMal(s);
      if (!ML.passar) {
        var einhver = GSTAERDIR.some(function (g) { return logoMal(s, g).passar; });
        ut.push({ kodi: "logo_dpi", reitur: "logo", stopp: true, texti: einhver ? t("logo.dpi", { s: heitiGsL(s.ls), px: s.logo.pxB, min: ML.minPx, mm: mmL(ML.l) }) : t("logo.dpi_ekkert", { px: s.logo.pxB, min: logoMal(s, "S").minPx }), hnappur: t("logo_villa_hnappur"), tillogur: einhver });
      }
    }
    return ut;
  }
  function heitiGsT(g) { return t("staerd_gildi", { s: g, mm: t("ts." + g) }); }
  /* logost\u00e6r\u00f0: raunst\u00e6r\u00f0in (lengd \u00d7 breidd) \u00feegar logo er komi\u00f0, annars nafnlengdin */
  function heitiGsL(g) { var ML = st.logo ? logoMal(st, g) : null; return t("staerd_gildi", { s: g, mm: ML ? t("malband", { l: mmL(ML.l), h: mmL(ML.h) }) : t("ls." + g) }); }
  function einn(n) { return n % 10 === 1 && n % 100 !== 11; }
  function athugaNu() { if (!athCache) athCache = athuga(); return athCache; }
  function vantar() { return athugaNu().filter(function (v) { return v.stopp; }); }
  function stadaok(s) { return !athuga(s).some(function (v) { return v.stopp; }); }
  function tillogur() {
    var ut = [];
    GSTAERDIR.forEach(function (g) {
      var s2 = afrit(st);
      if (st.hamur === "texti") { if (g === st.ts) return; s2.ts = g; }
      else { if (g === st.ls) return; s2.ls = g; }
      if (stadaok(s2)) ut.push({ tegund: st.hamur === "texti" ? "ts" : "ls", gildi: g, texti: st.hamur === "texti" ? heitiGsT(g) : heitiGsL(g) });
    });
    return ut;
  }
  /* ---- sm-brusi.js 1.0.1 lines 304-370 (verbatim) ---- */
  /* ================= Teikning: SVG \u00ed mm ofan \u00e1 lj\u00f3smyndinni ================= */
  var teikning = $("[data-bs-teikning]"), svid = $("[data-bs-svid]"), rammiEl = $("[data-bs-rammi]");
  var SVG_NS = "http://www.w3.org/2000/svg";
  var syn = 0;   /* 0 = allur br\u00fasinn, 1 = n\u00e6rmynd, 2... = myndir v\u00f6runnar */
  var synValid = false;
  function gluggi(s, naer) {
    var S = STAERDIR[s.staerd], R = S.thvermal / 2, mx = MYND_MM.midja, b = MYND_MM.botn;
    if (!naer) return { x: 0, y: 0, w: MYND_MM.w, h: MYND_MM.h };
    var y0 = b - S.svaedi[1] - 12, y1 = b + 6, x0 = mx - R - 18, x1 = mx + R + 18;
    return { x: x0, y: y0, w: x1 - x0, h: y1 - y0 };
  }
  function kassi() { if (!teikning) return null; var r = teikning.getBoundingClientRect(); return r.width > 10 && r.height > 10 ? { w: r.width, h: r.height } : null; }
  function aria(s) {
    s = s || st;
    var a = s.hamur === "logo" ? (s.logo ? t("aria_logo", { l: mmL(logoMal(s).l) }) : t("hamur.logo")) : (trim(s.texti) ? textiA(s.texti, s.letur) : t("hamur.texti"));
    return t("aria", { staerd: t("staerd." + s.staerd), litur: t("litur." + s.litur), aletrun: a });
  }
  /* SVG forsko\u00f0unarinnar. o: { naer, ks (px \u00e1 mm), smamynd } */
  function svgAf(s, o) {
    o = o || {};
    var S = STAERDIR[s.staerd], Li = LITIR[s.litur], R = S.thvermal / 2, mx = MYND_MM.midja, b = MYND_MM.botn;
    var W = gluggi(s, o.naer), ks = o.ks || 2, px = 1 / ks;
    var id = o.id || "bs";
    var slod = G.slodir && G.slodir.brusar && G.slodir.brusar[s.staerd + "-" + s.litur];
    var h = '<svg xmlns="' + SVG_NS + '" viewBox="' + r3(W.x) + " " + r3(W.y) + " " + r3(W.w) + " " + r3(W.h) + '" width="' + Math.round(W.w * ks) + '" height="' + Math.round(W.h * ks) + '" aria-hidden="true" focusable="false" data-ks="' + r4(ks) + '">';
    var zTop = b - S.svaedi[1], zBot = b - S.svaedi[0], oy = b - S.owala;
    h += "<defs><clipPath id=\"" + id + "k\"><rect x=\"0\" y=\"" + r3(zTop) + "\" width=\"" + r3(MYND_MM.w) + "\" height=\"" + r3(zBot - zTop) + "\"/></clipPath>";
    h += "<filter id=\"" + id + "g\" x=\"-20%\" y=\"-20%\" width=\"140%\" height=\"140%\" color-interpolation-filters=\"sRGB\">";
    var lag = [];
    Li.ljomi.forEach(function (L, i) {
      h += "<feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"" + r4(L[2] * 0.5 * px) + "\" result=\"" + id + "b" + i + "\"/>";
      h += "<feOffset in=\"" + id + "b" + i + "\" dx=\"" + r4(L[0] * px) + "\" dy=\"" + r4(L[1] * px) + "\" result=\"" + id + "o" + i + "\"/>";
      h += "<feFlood flood-color=\"" + L[3] + "\" flood-opacity=\"" + L[4] + "\"/><feComposite in2=\"" + id + "o" + i + "\" operator=\"in\" result=\"" + id + "s" + i + "\"/>";
      lag.push(id + "s" + i);
    });
    h += "<feMerge>" + lag.map(function (x) { return "<feMergeNode in=\"" + x + "\"/>"; }).join("") + "<feMergeNode in=\"SourceGraphic\"/></feMerge></filter></defs>";
    if (slod) h += '<image href="' + esc(slod) + '" x="0" y="0" width="' + r3(MYND_MM.w) + '" height="' + r3(MYND_MM.h) + '" preserveAspectRatio="none"/>';
    var lengd = 0, synid = false, yfir = false;
    if (s.hamur === "texti") {
      var tx = trim(s.texti) ? s.texti : t("syni"), M = textiMal({ staerd: s.staerd, texti: tx, ts: s.ts, letur: s.letur }), L = LETUR[s.letur];
      if (M.x) {
        synid = true;
        lengd = M.lengd; yfir = M.lengd > M.laust + 1e-6;
        var ax = mx + M.capA / 2, py = b - M.pen;
        h += stalTexti(id, '<text x="0" y="0" transform="translate(' + r4(ax) + " " + r4(py) + ') rotate(-90)" font-family="' + L.fam + '" font-size="' + r4(M.fs) + '" letter-spacing="' + r4(L.bil * M.fs) + '" style="font-kerning:normal;white-space:pre"',
          esc(M.x), Li, { x: mx - 20, y: zTop - 2, w: 40, h: zBot - zTop + 4, px: px, klippa: 'url(#' + id + 'k)', dauft: !trim(s.texti), lod: true });
      }
    } else if (s.logo) {
      var ML = logoMal(s), mynd = s.logo.forsyn && s.logo.forsyn[s.litur];
      if (ML && mynd) {
        synid = true; lengd = ML.l;
        h += '<g clip-path="url(#' + id + 'k)"><image href="' + mynd + '" x="0" y="' + r4(-ML.h / 2) + '" width="' + r4(ML.l) + '" height="' + r4(ML.h) + '" preserveAspectRatio="none" transform="translate(' + r4(mx) + " " + r4(oy) + ') rotate(-90)"/></g>';
      }
    }
    if (synid && !o.smamynd) {
      /* kvar\u00f0i: lengd \u00e1letrunarinnar, h\u00e6gra megin vi\u00f0 br\u00fasann */
      var kx = mx + R + 5, y1 = oy, y2 = oy - lengd, tick = 2.2, sw = r4(px * 1.2);
      h += '<g class="bs-kvardi" stroke="currentColor" stroke-width="' + sw + '" fill="none">';
      h += '<path d="M' + r3(kx) + " " + r3(y1) + "V" + r3(Math.max(y2, zTop - 0.001)) + "M" + r3(kx - tick) + " " + r3(y1) + "H" + r3(kx + tick) + "M" + r3(kx - tick) + " " + r3(Math.max(y2, zTop)) + "H" + r3(kx + tick) + '"/></g>';
      var fz = 11 * px, lab = mm0(lengd) + " mm", lw = (lab.length * 0.62 + 1.2) * fz, lh = fz * 1.7, cy = (y1 + Math.max(y2, zTop)) / 2;
      h += '<g transform="translate(' + r3(kx + 2.6 * px + lh / 2) + " " + r3(cy) + ') rotate(-90)"><rect class="bs-kvardi-bak" x="' + r3(-lw / 2) + '" y="' + r3(-lh / 2) + '" width="' + r3(lw) + '" height="' + r3(lh) + '" rx="' + r3(lh / 2) + '"/>';
      h += '<text class="bs-kvardi-texti" x="0" y="' + r3(fz * 0.36) + '" font-size="' + r4(fz) + '" text-anchor="middle">' + esc(lab) + "</text></g>";
      if (yfir) h += '<path class="bs-yfir" d="M' + r3(mx - R) + " " + r3(zTop) + "H" + r3(mx + R) + '" stroke-width="' + r4(px * 1.5) + '" stroke-dasharray="' + r4(px * 4) + " " + r4(px * 3) + '"/>';
    }
    return h + "</svg>";
  }
  /* stal-letur: engraved letters as the laser leaves them, the powder coat cut away and brushed stainless steel
     showing. tx0 = the text element without fill (position, font, size), txt = the escaped text, Li = LITIR[litur],
     o = { x, y, w, h: the steel sheet behind the letters (user units, mm on the bottle), px: one screen pixel in
     user units, klippa: clip-path url or "", dauft: placeholder at half opacity, lod: the sheet lies along the
     bottle (its grain runs around it; false = the tile's horizontal text, the sheet is turned) }.
     Layer 1: the text in the colour of the cut edge with a thin rim and the bottle's glow (the old filter), so a
     fine edge shows around the steel. Layer 2: the steel texture and a cylinder light (lighter band left of
     the middle, darker edges) masked by the text itself. Without the texture URL the old flat fill is used. */
  function stalTexti(id, tx0, txt, Li, o) {
    var stal = G.slodir && G.slodir.stal, h = '<g' + (o.klippa ? ' clip-path="' + o.klippa + '"' : "") + '><g' + (o.dauft ? ' opacity=".5"' : "") + ">";
    if (!stal) return h + '<g filter="url(#' + id + 'g)">' + tx0 + ' fill="' + Li.grafa + '">' + txt + "</text></g></g></g>";
    var rim = r4(Math.max(0.08, o.px * 0.7)), S = Li.stal;
    h += '<g filter="url(#' + id + 'g)">' + tx0 + ' fill="' + Li.brun + '" stroke="' + Li.brun + '" stroke-width="' + rim + '" stroke-linejoin="round">' + txt + "</text></g>";
    h += "<defs>";
    h += '<mask id="' + id + 'm" maskUnits="userSpaceOnUse" x="' + r3(o.x) + '" y="' + r3(o.y) + '" width="' + r3(o.w) + '" height="' + r3(o.h) + '">' + tx0 + ' fill="#fff">' + txt + "</text></mask>";
    var gx = o.lod ? [r3(o.x), r3(o.y), r3(o.x + o.w), r3(o.y)] : [r3(o.x), r3(o.y + o.h), r3(o.x), r3(o.y)];
    h += '<linearGradient id="' + id + 'h" gradientUnits="userSpaceOnUse" x1="' + gx[0] + '" y1="' + gx[1] + '" x2="' + gx[2] + '" y2="' + gx[3] + '">' +
      '<stop offset="0" stop-color="#000" stop-opacity="' + S.dokkt + '"/><stop offset=".2" stop-color="#000" stop-opacity="0"/><stop offset=".38" stop-color="#fff" stop-opacity="' + S.ljos + '"/>' +
      '<stop offset=".58" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity="' + S.dokkt + '"/></linearGradient></defs>';
    h += '<g mask="url(#' + id + 'm)">';
    if (o.lod) h += '<image href="' + esc(stal) + '" x="' + r3(o.x) + '" y="' + r3(o.y) + '" width="' + r3(o.w) + '" height="' + r3(o.h) + '" preserveAspectRatio="none"/>';
    else h += '<image href="' + esc(stal) + '" x="' + r3(-o.y - o.h) + '" y="' + r3(o.x) + '" width="' + r3(o.h) + '" height="' + r3(o.w) + '" preserveAspectRatio="none" transform="rotate(-90)"/>';
    h += '<rect x="' + r3(o.x) + '" y="' + r3(o.y) + '" width="' + r3(o.w) + '" height="' + r3(o.h) + '" fill="' + S.grunn + '"/>';
    h += '<rect x="' + r3(o.x) + '" y="' + r3(o.y) + '" width="' + r3(o.w) + '" height="' + r3(o.h) + '" fill="url(#' + id + 'h)"/></g>';
    return h + "</g></g>";
  }
  /* ---- sm-brusi.js 1.0.1 lines 587-619 (verbatim) ---- */
  /* ================= Textareiturinn: a\u00f0eins stafir sem letri\u00f0 hefur ================= */
  function hreinsaTexta(v, f) {
    var id = LETUR[f].id, cps = kodapunktar(nfc(v).replace(/[\r\n\t]+/g, " ")), ut = [], burt = [], takn = false;
    cps.forEach(function (c) {
      var ch = fraKodum([c]);
      if (c === 32) { ut.push(c); return; }
      if (TAKN_RE.test(ch) || c === 0xfe0f || c === 0x200d) { takn = true; return; }
      var upp = LETUR[f].hastafir ? kodapunktar(ch.toUpperCase()) : [c];
      if (upp.every(function (u) { return hefurStaf(id, u); })) ut.push(c);
      else { var sy = synilegt(c, ch); if (burt.indexOf(sy) < 0) burt.push(sy); }
    });
    return { texti: fraKodum(ut), takn: takn, burt: burt };
  }
  /* stafur sem s\u00e9st \u00ed \u00e1bendingunni: sammerki (t.d. tv\u00edpunktur sem \u00e1 s\u00e9r engan samsettan staf) \u00e1 punktahring,
     \u00f3s\u00fdnilegir stafir og s\u00e9rst\u00f6k bil me\u00f0 k\u00f3\u00f0anum s\u00ednum, svo listinn s\u00e9 aldrei au\u00f0ur a\u00f0 sj\u00e1 */
  /* flokkarnir koma \u00far Unicode vi\u00f0 sm\u00ed\u00f0i (build.mjs): bil sem runa grunntala 36, [fr\u00e1 fyrra bili, lengd] */
  var BIL_TXT = { s: "lc,26,2,v,7o,6,7c,18,2,0,2,1,2,1,2,0,21,a,1d,k,h,0,2u,6,3,5,3,1,2,3,10,0,v,q,2k,a,1n,8,a,0,p,3,2,8,2,2,2,4,18,2,1o,8,17,n,2,w,1j,2,2,h,2,6,b,1,u,2,1l,0,2,6,3,1,3,2,a,0,b,1,r,0,3,2,1l,0,2,4,5,1,3,2,4,0,v,1,4,0,c,2,1l,0,2,7,2,2,2,2,l,1,n,5,2,2,1l,0,2,6,3,1,3,2,8,2,b,1,v,0,1o,4,4,2,2,3,a,0,15,4,1k,0,2,6,2,2,2,3,8,1,c,1,u,2,1l,0,2,6,2,2,2,3,8,1,c,1,g,0,d,3,1k,1,2,6,2,2,2,3,a,0,b,1,u,2,1z,0,5,5,2,0,2,7,j,1,1q,0,3,6,d,7,2r,0,3,8,c,6,22,1,s,0,2,0,2,0,5,1,1e,j,2,1,6,a,2,z,a,0,2t,j,o,3,5,2,2,2,3,6,4,3,e,b,2,0,b,3,jk,2,qb,3,t,2,u,1,v,1,1v,t,a,0,4o,1,z,0,3b,b,5,b,64,4,1m,9,2,s,3,0,1d,19,3,b,l,4,1c,g,13,8,d,2,v,c,1l,d,1d,j,49,2,2,k,5,0,7,0,3,2,5j,1r,k1,w,2db,2,3y,0,2p,v,ff,5,2y,1,n9x,3,2,9,x,1,29,1,7l,0,4,0,5,0,o,4,5,0,2c,1,1f,h,r,h,e,0,13,7,q,c,19,3,1c,d,11,0,1w,d,d,0,9,1,1a,2,1f,0,2,2,3,1,6,1,2,0,16,4,6,1,6l,7,2,1,fn5,0,le,f,r2,0,6b,0,46,4,1af,2,2,1,6,3,15,2,5,0,4m,1,fy,3,1u,4,8u,1,26,5,1z,a,1e,3,3f,2,1i,e,16,0,3,1,b,3,1a,a,8,0,1q,2,11,d,h,1,19,0,d,2,1d,d,9,3,2,1,2l,b,7,0,3,0,4e,b,m,3,1k,1,2,6,3,1,3,2,a,0,b,1,3,6,4,4,1w,8,2,0,3,0,2,3,2,4,2,0,f,1,2b,h,o,0,2a,j,6k,6,3,8,s,1,2b,g,2z,c,2u,e,75,e,6u,5,2,1,3,3,2,0,2,1,3y,6,3,6,4,0,t,9,15,6,2,3,9,0,a,a,1b,f,5j,7,5k,7,2,7,2b,l,2,d,3f,5,4,0,2,1,2,6,2,0,1v,4,2,1,2,4,9o,3,a,1,2,0,1d,6,4,4,o,0,44m,0,7,e,8uh,h,1xd,4,1o,6,t5,0,2,1i,8,3,2a,0,c,1,f58,1,3mq,19,3,m,f3,4,4,5,9,7,3,6,v,3,45,2,1j0,1i,5,1d,9,0,f,0,n,4,2,e,11t,6,2,g,3,6,2,1,2,4,2t,0,4h,6,ag,0,1q,3,e5,3,73,1,6s,0,3,0,8,1,6,0,d7,6,32,6", o: "0,v,2o,x,d,0,iq,0,j5,5,n,0,5d,0,1e,0,ap,1,29,0,1od,1,10g,0,8k,1,2e,4,1kh,f,p,7,1c,g,32p,0,9w,0,wws,6in,zl,f,6o,0,4h,0,28,b,3b6,0,g,0,6zn,f,qxt,3,440,7,h406,35r,1bep,1ekd,3,1ekd" }, BIL = {};
  function iBili(k, c) {
    var L = BIL[k], i, x = 0, lo = 0, hi;
    if (!L) {
      var a = BIL_TXT[k].split(",");
      L = BIL[k] = [];
      for (i = 0; i + 1 < a.length; i += 2) { x += parseInt(a[i], 36); L.push([x, x + parseInt(a[i + 1], 36)]); x += parseInt(a[i + 1], 36); }
    }
    hi = L.length - 1;
    while (lo <= hi) { i = (lo + hi) >> 1; if (c < L[i][0]) hi = i - 1; else if (c > L[i][1]) lo = i + 1; else return true; }
    return false;
  }
  function synilegt(c, ch) {
    if (iBili("o", c)) { var h = c.toString(16).toUpperCase(); while (h.length < 4) h = "0" + h; return "U+" + h; }
    if (iBili("s", c)) return "\u25cc" + ch;
    return ch;
  }
  /* ---- sm-brusi.js 1.0.1 lines 650-814 (verbatim) ---- */
  /* ================= Logo: greining (klippa, einn litur, gegns\u00e6tt, dpi) ================= */
  function lesaSkraTexta(skra) {
    if (skra && typeof skra.text === "function") return skra.text();
    return new Promise(function (res, rej) { var r = new FileReader(); r.onload = function () { res(String(r.result)); }; r.onerror = rej; r.readAsText(skra); });
  }
  function hladaMynd(url) {
    return new Promise(function (res, rej) { var img = new Image(); img.onload = function () { res(img); }; img.onerror = function () { rej(villaL("logo.lesa")); }; img.src = url; });
  }
  function villaL(k) { var e = new Error(t(k)); e.logo = k; return e; }
  /* ImageData -> gegns\u00e6i, blekkassi, hlutfall annarra lita */
  function greina(d, w, h) {
    var p = d.data, n = w * h, gegns = 0, x0 = w, y0 = h, x1 = -1, y1 = -1, i, x, y;
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
        i = (y * w + x) * 4;
        var a = p[i + 3];
        if (a < 10) gegns++;
        if (a > 25) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
    }
    /* litir \u00f3gegns\u00e6ju d\u00edlanna, 32 \u00ferep \u00e1 r\u00e1s: \u00feekja 10 algengustu (l\u00e1gt = skygging, litaskil e\u00f0a lj\u00f3smynd)
       og fj\u00f6ldi a\u00f0greindra lita (h\u00f3par sem n\u00e1 3 %) */
    var hist = {}, tal = 0, skref = Math.max(1, Math.floor(n / 400000));
    for (i = 0; i < n; i += skref) {
      var j = i * 4;
      if (p[j + 3] <= 200) continue;
      var q = ((p[j] >> 3) << 10) | ((p[j + 1] >> 3) << 5) | (p[j + 2] >> 3);
      hist[q] = (hist[q] || 0) + 1; tal++;
    }
    var hol = Object.keys(hist).map(function (k) { return [+k, hist[k]]; }).sort(function (a2, b2) { return b2[1] - a2[1]; });
    var thekja = 0, hopar = [];
    hol.forEach(function (e, ix) {
      if (ix < 10) thekja += e[1];
      var r = e[0] >> 10, g = (e[0] >> 5) & 31, b = e[0] & 31, fann = false;
      hopar.forEach(function (H) { if (!fann && Math.abs(H.r - r) <= 4 && Math.abs(H.g - g) <= 4 && Math.abs(H.b - b) <= 4) { H.n += e[1]; fann = true; } });
      if (!fann) hopar.push({ r: r, g: g, b: b, n: e[1] });
    });
    var fjoldi = hopar.filter(function (H) { return tal && H.n / tal >= 0.03; }).length;
    return { gegns: gegns / n, kassi: x1 >= 0 ? { x: x0, y: y0, w: x1 - x0 + 1, h: y1 - y0 + 1 } : null, thekja: tal ? thekja / tal : 1, litir: fjoldi };
  }
  function klippa(c, K) { var c2 = document.createElement("canvas"); c2.width = K.w; c2.height = K.h; c2.getContext("2d").drawImage(c, K.x, K.y, K.w, K.h, 0, 0, K.w, K.h); return c2; }
  /* Lita\u00f0 afrit fyrir forsko\u00f0un: gr\u00e1t\u00f3nn (Claude Design s\u00eda) me\u00f0 alfa logosins, mest 1400 px \u00e1 lengd */
  function lita(maski, gildi) {
    var k = Math.min(1, 1400 / Math.max(maski.width, maski.height)), w = Math.max(1, Math.round(maski.width * k)), h = Math.max(1, Math.round(maski.height * k));
    var c = document.createElement("canvas"); c.width = w; c.height = h;
    var x = c.getContext("2d"); x.drawImage(maski, 0, 0, w, h);
    x.globalCompositeOperation = "source-in"; x.fillStyle = "rgb(" + gildi + "," + gildi + "," + gildi + ")"; x.fillRect(0, 0, w, h);
    return c.toDataURL("image/png");
  }
  function klaraLogo(maski, gerd, pxB, litir) {
    var forsyn = {}, k;
    for (k in LITIR) if (has(LITIR, k)) forsyn[k] = lita(maski, LITIR[k].logo);
    return { gerd: gerd, maski: maski, pxB: pxB, cw: maski.width, ch: maski.height, r: maski.width / maski.height, forsyn: forsyn, mjott: {}, litir: litir || 1 };
  }
  function greinaPng(skra) {
    var url = URL.createObjectURL(skra);
    return hladaMynd(url).then(function (img) {
      URL.revokeObjectURL(url);
      var w0 = img.naturalWidth, h0 = img.naturalHeight;
      if (!w0 || !h0) throw villaL("logo.lesa");
      var sk = Math.min(1, 6000 / Math.max(w0, h0)), w = Math.max(1, Math.round(w0 * sk)), h = Math.max(1, Math.round(h0 * sk));
      var c = document.createElement("canvas"); c.width = w; c.height = h;
      var x = c.getContext("2d"); x.drawImage(img, 0, 0, w, h);
      var d;
      try { d = x.getImageData(0, 0, w, h); } catch (e) { throw villaL("logo.lesa"); }
      var A = greina(d, w, h);
      if (!A.kassi) throw villaL("logo.tomt");
      if (A.gegns < 0.02 && A.kassi.w >= w - 1 && A.kassi.h >= h - 1) throw villaL("logo.gegnsaett");
      if (A.thekja < 0.85) throw villaL("logo.litir");
      var m = klippa(c, A.kassi);
      return klaraLogo(m, "png", Math.round(A.kassi.w / sk), A.litir);
    }, function (e) { URL.revokeObjectURL(url); throw e; });
  }
  var EININGAR = { px: 1, pt: 4 / 3, pc: 16, mm: 96 / 25.4, cm: 96 / 2.54, "in": 96, "": 1 };
  function lengdSvg(s) { var m = /^\s*([0-9.]+)\s*(px|pt|pc|mm|cm|in)?\s*$/.exec(s || ""); return m ? parseFloat(m[1]) * EININGAR[m[2] || ""] : null; }
  /* SVG: r\u00f3tin f\u00e6r n\u00fdjan viewBox (a\u00f0eins bleki\u00f0) og breidd \u00ed px, svo vafrinn teiknar logoi\u00f0 beint \u00ed r\u00e9ttri upplausn */
  function svgMed(txt, vb, w, h) {
    var m = /<svg\b[^>]*>/i.exec(txt);
    if (!m) return null;
    var tag = m[0].replace(/\s(width|height|viewBox|preserveAspectRatio|x|y)\s*=\s*("[^"]*"|'[^']*')/gi, "");
    tag = tag.replace(/<svg\b/i, '<svg width="' + w + '" height="' + h + '" viewBox="' + vb.join(" ") + '" preserveAspectRatio="none"');
    return txt.slice(0, m.index) + tag + txt.slice(m.index + m[0].length);
  }
  function teiknaSvg(txt, vb, w, h) {
    var s = svgMed(txt, vb, w, h);
    if (!s) return Promise.reject(villaL("logo.lesa"));
    var url = URL.createObjectURL(new Blob([s], { type: "image/svg+xml" }));
    return hladaMynd(url).then(function (img) {
      URL.revokeObjectURL(url);
      var c = document.createElement("canvas"); c.width = w; c.height = h;
      c.getContext("2d").drawImage(img, 0, 0, w, h);
      var d;
      try { d = c.getContext("2d").getImageData(0, 0, w, h); } catch (e) { throw villaL("logo.lesa"); }
      return { c: c, d: d };
    }, function (e) { URL.revokeObjectURL(url); throw e; });
  }
  function greinaSvg(skra) {
    return lesaSkraTexta(skra).then(function (txt) {
      var m = /<svg\b[^>]*>/i.exec(txt);
      if (!m) throw villaL("logo.lesa");
      var vbm = /\sviewBox\s*=\s*["']([^"']+)["']/i.exec(m[0]), vb = null;
      if (vbm) { vb = vbm[1].split(/[\s,]+/).map(parseFloat); if (vb.length !== 4 || !(vb[2] > 0) || !(vb[3] > 0) || vb.some(isNaN)) vb = null; }
      if (!vb) {
        var wm = /\swidth\s*=\s*["']([^"']+)["']/i.exec(m[0]), hm = /\sheight\s*=\s*["']([^"']+)["']/i.exec(m[0]);
        var ww = wm && lengdSvg(wm[1]), hh = hm && lengdSvg(hm[1]);
        if (!(ww > 0 && hh > 0)) throw villaL("logo.lesa");
        vb = [0, 0, ww, hh];
      }
      /* umfer\u00f0 1: allt, lengri hli\u00f0in 1600 px, til a\u00f0 finna bleki\u00f0 */
      var k1 = 1600 / Math.max(vb[2], vb[3]), w1 = Math.max(1, Math.round(vb[2] * k1)), h1 = Math.max(1, Math.round(vb[3] * k1));
      return teiknaSvg(txt, vb, w1, h1).then(function (R1) {
        var A = greina(R1.d, w1, h1);
        if (!A.kassi) throw villaL("logo.tomt");
        if (A.gegns < 0.02 && A.kassi.w >= w1 - 1 && A.kassi.h >= h1 - 1) throw villaL("logo.gegnsaett");
        if (A.thekja < 0.85) throw villaL("logo.litir");
        /* umfer\u00f0 2: a\u00f0eins bleki\u00f0 (+ 1 px), \u00ed 600 dpi \u00e1 lengstu st\u00e6r\u00f0inni */
        var sx = vb[2] / w1, sy = vb[3] / h1, K = A.kassi;
        var vb2 = [vb[0] + (K.x - 1) * sx, vb[1] + (K.y - 1) * sy, (K.w + 2) * sx, (K.h + 2) * sy];
        var r = vb2[2] / vb2[3], lmax = Math.min(LOGO_MM.L, LOGO_THVERT * r);
        var w2 = Math.min(8000, Math.ceil(lmax / 25.4 * DPI_SKRA * 1.02)), h2 = Math.max(1, Math.round(w2 / r));
        if (h2 > 8000) { h2 = 8000; w2 = Math.max(1, Math.round(h2 * r)); }
        return teiknaSvg(txt, vb2.map(function (v) { return r4(v); }), w2, h2).then(function (R2) {
          var A2 = greina(R2.d, w2, h2);
          if (!A2.kassi) throw villaL("logo.tomt");
          return klaraLogo(klippa(R2.c, A2.kassi), "svg", Infinity, A.litir);
        });
      });
    });
  }
  function greinaLogo(skra) {
    var e = ((/\.([a-z0-9]+)$/i.exec(skra && skra.name || "") || [])[1] || "").toLowerCase();
    try {
      if (e === "png" || skra.type === "image/png") return greinaPng(skra);
      if (e === "svg" || skra.type === "image/svg+xml") return greinaSvg(skra);
    } catch (x) { return Promise.reject(villaL("logo.lesa")); }
    return Promise.reject(villaL("logo.gerd"));
  }
  /* Mj\u00f3ar l\u00ednur: opnun (rof + \u00feensla) me\u00f0 0,4 mm ferningi \u00e1 12,5 px/mm; \u00fea\u00f0 sem hverfur er mj\u00f3rra en 0,4 mm */
  function logoMjott() {
    var lg = st.logo; if (!lg) return false;
    var ML = logoMal(), kl = lg.mjott[st.ls];
    if (kl != null) return kl;
    var pxmm = 12.5, w = Math.max(1, Math.round(ML.l * pxmm)), h = Math.max(1, Math.round(ML.h * pxmm));
    var c = document.createElement("canvas"); c.width = w; c.height = h;
    var x = c.getContext("2d"); x.drawImage(lg.maski, 0, 0, w, h);
    var p = x.getImageData(0, 0, w, h).data, n = w * h, a = new Uint8Array(n), i, j, blek = 0;
    for (i = 0; i < n; i++) { a[i] = p[i * 4 + 3] > 127 ? 1 : 0; blek += a[i]; }
    var r = Math.round(MIN_STROKA / 2 * pxmm);
    function sia(inn, mini, lar) {
      var tmp = new Uint8Array(n), ut = new Uint8Array(n), X, Y, k, v;
      for (Y = 0; Y < h; Y++) for (X = 0; X < w; X++) {
        v = mini ? 1 : 0;
        for (k = -r; k <= r; k++) { var xx = lar ? X + k : X, yy = lar ? Y : Y + k; var q = (xx < 0 || yy < 0 || xx >= w || yy >= h) ? 0 : inn[yy * w + xx]; if (mini) { if (!q) { v = 0; break; } } else if (q) { v = 1; break; } }
        tmp[Y * w + X] = v;
      }
      if (lar) return tmp;
      for (j = 0; j < n; j++) ut[j] = tmp[j];
      return ut;
    }
    var rof = sia(sia(a, true, true), true, false), opn = sia(sia(rof, false, true), false, false), hvarf = 0;
    for (i = 0; i < n; i++) if (a[i] && !opn[i]) hvarf++;
    var nid = blek > 0 && hvarf / blek > 0.05;
    lg.mjott[st.ls] = nid;
    return nid;
  }
  /* ---- sm-brusi.js 1.0.1 lines 917-999 (verbatim) ---- */
  /* ================= Framlei\u00f0sluskr\u00e1 (SMFram) ================= */
  function uppruniLogo() { return st.logoSkra ? st.logoSkra.name : ""; }
  function framMynd(lg, ML) {
    /* PNG: upprunalegu d\u00edlarnir (mest 1200 dpi); SVG: teikna\u00f0 \u00ed 600 dpi */
    var max = Math.ceil(ML.l / 25.4 * DPI_HAMARK);
    if (lg.maski.width <= max) return lg.maski;
    var k = max / lg.maski.width, c = document.createElement("canvas");
    c.width = max; c.height = Math.max(1, Math.round(lg.maski.height * k));
    c.getContext("2d").drawImage(lg.maski, 0, 0, c.width, c.height);
    return c;
  }
  function specAf(s) {
    s = s || st;
    var S = STAERDIR[s.staerd], Li = LITIR[s.litur], D = S.thvermal, R = D / 2, Mg = SKRA_SPASSIA;
    var x0 = Mg, yA = Mg + R, w = r3(2 * Mg + S.bolur), h = r3(2 * Mg + D), hlutir = [], lysing = [], gogn;
    var sv0 = x0 + S.svaedi[0], sv1 = x0 + S.svaedi[1], ow = x0 + S.owala, band = LOGO_THVERT / 2;
    lysing.push(["Br\u00fasi", "Owala FreeSip " + t("staerd." + s.staerd) + " (" + t("oz." + s.staerd) + "), " + Li.heiti + " (" + Li.owala + "), ry\u00f0fr\u00edtt st\u00e1l"]);
    gogn = { hamur: s.hamur, stadsetning: STADSETNING, staerd: s.staerd, litur: s.litur, owala: S.owala, svaedi: S.svaedi, thvermal: D, bolur: S.bolur, sida: "sm-brusi.js " + UTGAFA };
    if (s.hamur === "texti") {
      var L = LETUR[s.letur], M = textiMal(s);
      hlutir.push({ gerd: "texti", lag: "GRAFA", texti: M.x, letur: L.id, mm: r4(M.fs), x: r4(x0 + M.pen), y: r4(yA + M.capA / 2), jofnun: "vinstri", stafabil: L.bil, gfSvid: false });
      lysing.push(["\u00c1letrun", "Texti: " + M.x]);
      lysing.push(["Letur", L.nafn + " " + L.thykkt + ", stafabil " + String(L.bil).replace(".", ",") + " em"]);
      lysing.push(["Stafah\u00e6\u00f0", stafahaedTexti(s.ts, M) + " (leturst\u00e6r\u00f0 " + mm1(M.fs) + " mm, h\u00e1stafir " + mm1(M.capA) + " mm)"]);
      lysing.push(["Lengd", mm1(M.lengd) + " mm af " + mm1(M.laust) + " mm lausum"]);
      gogn.texti = M.x; gogn.letur = L.id; gogn.stafahaed = M.cap; gogn.stafahaedValin = M.cap0; gogn.minnkad = M.minnkad; gogn.leturstaerd = r3(M.fs); gogn.lengd = r3(M.lengd); gogn.penni = r3(M.pen); gogn.staerdKodi = s.ts;
    } else {
      var ML = logoMal(s), lg = s.logo;
      hlutir.push({ gerd: "mynd", lag: "GRAFA-MYND", src: framMynd(lg, ML), maski: true, nafn: "logo", x: r4(ow), y: r4(yA - ML.h / 2), w: r4(ML.l), h: r4(ML.h) });
      lysing.push(["\u00c1letrun", "Logo: " + uppruniLogo() + " (" + lg.gerd.toUpperCase() + ")"]);
      lysing.push(["Logo", s.ls + " " + mm1(ML.l) + " \u00d7 " + mm1(ML.h) + " mm" + (lg.gerd === "png" ? ", " + Math.round(ML.dpi) + " dpi" : ", teikna\u00f0 \u00ed " + DPI_SKRA + " dpi")]);
      gogn.logo = uppruniLogo(); gogn.logoGerd = lg.gerd; gogn.logoLengd = r3(ML.l); gogn.logoBreidd = r3(ML.h); gogn.staerdKodi = s.ls;
      if (lg.gerd === "png") gogn.dpi = Math.round(ML.dpi);
    }
    lysing.push(["Sta\u00f0setning", "Br\u00fasinn liggur \u00e1 hli\u00f0, botninn vi\u00f0 vinstri br\u00fan (x = " + Mg + " mm), toppurinn \u00e1 mi\u00f0l\u00ednunni (y = " + mm1(yA) + " mm). \u00c1letrunin byrjar " + mm1(S.owala) + " mm fr\u00e1 botni, \u00ed l\u00ednu vi\u00f0 botn Owala merkisins, og les fr\u00e1 botni a\u00f0 h\u00e1lsi."]);
    lysing.push(["Grafsv\u00e6\u00f0i", mm1(S.svaedi[0]) + " til " + mm1(S.svaedi[1]) + " mm fr\u00e1 botni (UTLINA). Loki\u00f0 af."]);
    /* UTLINA: \u00fatl\u00edna br\u00fasans ofan fr\u00e1, grafsv\u00e6\u00f0i\u00f0, botnl\u00edna, mi\u00f0l\u00edna og l\u00edna Owala merkisins */
    var rb = 10, y0 = Mg, y1 = Mg + D, xe = x0 + S.bolur;
    hlutir.push({ gerd: "slod", lag: "UTLINA", d: "M" + r3(x0 + rb) + " " + r3(y0) + "H" + r3(xe) + "V" + r3(y1) + "H" + r3(x0 + rb) + "A" + rb + " " + rb + " 0 0 1 " + r3(x0) + " " + r3(y1 - rb) + "V" + r3(y0 + rb) + "A" + rb + " " + rb + " 0 0 1 " + r3(x0 + rb) + " " + r3(y0) + "Z" });
    if (S.oxl) hlutir.push({ gerd: "slod", lag: "UTLINA", d: "M" + r3(x0 + S.oxl[0]) + " " + r3(y0) + "V" + r3(y1) });
    hlutir.push({ gerd: "rett", lag: "UTLINA", x: r3(sv0), y: r3(yA - band), w: r3(sv1 - sv0), h: r3(2 * band) });
    hlutir.push({ gerd: "slod", lag: "UTLINA", d: "M" + r3(x0) + " " + r3(y0 - 3) + "V" + r3(y1 + 3) });
    hlutir.push({ gerd: "slod", lag: "UTLINA", d: "M" + r3(sv0 - 3) + " " + r3(yA) + "H" + r3(sv1 + 3) });
    hlutir.push({ gerd: "slod", lag: "UTLINA", d: "M" + r3(ow) + " " + r3(yA - band - 2) + "V" + r3(yA + band + 2) });
    return { vara: "brusi", efni: s.litur, staerd: s.staerd, ord: s.hamur === "texti" ? textiA(s.texti, s.letur) : "logo", titill: (G.vara && G.vara.titill) || "", snid: "brusi@1", w: w, h: h, lysing: lysing, gogn: gogn, hlutir: hlutir };
  }
  /* M\u00e6ling \u00e1 skr\u00e1nni: kassi um alla ferla \u00ed GRAFA (st\u00fdripunktar me\u00f0), innan sv\u00e6\u00f0isins */
  function lesaD(d, K) {
    var tok = String(d).match(/[a-zA-Z]|-?(?:\d+\.?\d*|\.\d+)(?:e[-+]?\d+)?/g) || [], i = 0, cmd = "", x = 0, y = 0, sx = 0, sy = 0;
    function tala() { return parseFloat(tok[i++]); }
    function pt(px, py) { if (px < K[0]) K[0] = px; if (py < K[1]) K[1] = py; if (px > K[2]) K[2] = px; if (py > K[3]) K[3] = py; }
    while (i < tok.length) {
      if (/[a-zA-Z]/.test(tok[i])) cmd = tok[i++];
      var rel = cmd === cmd.toLowerCase(), C = cmd.toUpperCase(), a, b2, c, d2, e, f;
      if (C === "Z") { x = sx; y = sy; continue; }
      if (C === "M") { a = tala(); b2 = tala(); x = rel ? x + a : a; y = rel ? y + b2 : b2; sx = x; sy = y; pt(x, y); cmd = rel ? "l" : "L"; }
      else if (C === "L") { a = tala(); b2 = tala(); x = rel ? x + a : a; y = rel ? y + b2 : b2; pt(x, y); }
      else if (C === "H") { a = tala(); x = rel ? x + a : a; pt(x, y); }
      else if (C === "V") { a = tala(); y = rel ? y + a : a; pt(x, y); }
      else if (C === "C") { a = tala(); b2 = tala(); c = tala(); d2 = tala(); e = tala(); f = tala(); pt(rel ? x + a : a, rel ? y + b2 : b2); pt(rel ? x + c : c, rel ? y + d2 : d2); x = rel ? x + e : e; y = rel ? y + f : f; pt(x, y); }
      else if (C === "Q") { a = tala(); b2 = tala(); c = tala(); d2 = tala(); pt(rel ? x + a : a, rel ? y + b2 : b2); x = rel ? x + c : c; y = rel ? y + d2 : d2; pt(x, y); }
      else { i++; }
    }
    return K;
  }
  function athugaSkra(svg, spec) {
    var s = spec.gogn, S = STAERDIR[s.staerd], Mg = SKRA_SPASSIA, out = { ok: true, kassi: null };
    if (s.hamur !== "texti") return out;
    var i0 = svg.search(/id="[0-9]*-?GRAFA"/);
    if (i0 < 0) { out.ok = false; return out; }
    var i1 = svg.indexOf('inkscape:groupmode="layer"', i0 + 20);
    var hluti = svg.slice(i0, i1 < 0 ? svg.length : i1), K = [Infinity, Infinity, -Infinity, -Infinity], m, re = /\sd="([^"]+)"/g;
    while ((m = re.exec(hluti))) lesaD(m[1], K);
    out.kassi = K.map(function (v) { return r3(v); });
    if (!(K[2] > K[0])) { out.ok = false; return out; }
    out.ok = K[0] >= Mg + S.svaedi[0] - 0.05 && K[2] <= Mg + S.svaedi[1] + 0.3;
    return out;
  }
  function lesaBlob(b) {
    if (b && typeof b.text === "function") return b.text();
    return new Promise(function (res, rej) { var r = new FileReader(); r.onload = function () { res(String(r.result)); }; r.onerror = rej; r.readAsText(b); });
  }
  function skraVilla() { var e = new Error(t("skra_villa")); e.skra = true; return e; }
  /* ---- sm-brusi.js 1.0.1 lines 1021-1039 (verbatim) ---- */
  /* ================= Karfa ================= */
  function stafahaedTexti(ts, M) { return t(M.minnkad ? "stafahaed_minnkad" : "stafahaed_gildi", { s: ts, mm: mm1(M.cap), fra: mm1(M.cap0) }); }
  function eiginleikar(s) {
    s = s || st;
    var ut = {};
    if (s.hamur === "texti") {
      var M = textiMal(s);
      ut[EIG.aletrun] = EIG_GILDI.texti;
      ut[EIG.texti] = M.x;
      ut[EIG.letur] = t("letur_nafn." + s.letur);
      ut[EIG.stafahaed] = stafahaedTexti(s.ts, M);
    } else {
      var ML = logoMal(s);
      ut[EIG.aletrun] = EIG_GILDI.logo;
      ut[EIG.logolengd] = mmL(ML.l) + " \u00d7 " + mmL(ML.h) + " mm";
    }
    ut[EIG.stadsetning] = EIG_GILDI.stadsetning;
    if (trim(s.aths)) ut[EIG.aths] = trim(s.aths);
    return ut;
  }
  /* ---- sm-brusi.js 1.0.1 lines 1053-1055 (verbatim) ---- */
  function smamynd() {
    try { return svgAf(st, { naer: true, ks: 1, id: "bsk", smamynd: true }).replace("<svg ", '<svg style="width:100%;height:100%" '); } catch (e) { return ""; }
  }
  /* ---- the library (new) ---- */
  return {
    UTGAFA: UTGAFA, MYND: MYND, MYND_MM: MYND_MM, STAERDIR: STAERDIR, LITIR: LITIR, LETUR: LETUR, LETUR_ROD: LETUR_ROD,
    TEXTI_MM: TEXTI_MM, LOGO_MM: LOGO_MM, GSTAERDIR: GSTAERDIR, EIG: EIG, EIG_GILDI: EIG_GILDI, TAKN_RE: TAKN_RE,
    kodarOk: function () { return KODAR_OK; }, gildiAf: gildiAf, kodiAf: kodiAf, finna: finna,
    stada: function () { return st; }, setjaSt: setjaSt, afrit: afrit,
    leturKlar: function (f) { return !!leturKlar[f]; }, leturVilla: function () { return leturVilla; },
    hladaLetur: hladaLetur, skraIKjarna: skraIKjarna,
    t: t, esc: esc, trim: trim, mm0: mm0, mm1: mm1, mmL: mmL, r3: r3, r4: r4, nfc: nfc, kodapunktar: kodapunktar,
    hefurStaf: hefurStaf, textiA: textiA, stafafjoldi: stafafjoldi, maela: maela, hamarkStafa: hamarkStafa, textiMal: textiMal, logoMal: logoMal,
    athuga: athuga, heitiGsT: heitiGsT, heitiGsL: heitiGsL, einn: einn, stadaok: stadaok, tillogur: tillogur,
    gluggi: gluggi, aria: aria, svgAf: svgAf, hreinsaTexta: hreinsaTexta, synilegt: synilegt,
    greinaLogo: greinaLogo, lita: lita, logoMjott: logoMjott, specAf: specAf, athugaSkra: athugaSkra, lesaBlob: lesaBlob,
    eiginleikar: eiginleikar, smamynd: smamynd, stalTexti: stalTexti, stafahaedTexti: stafahaedTexti
  };
  }
  window.SMBrusiVel = vel;
})();
